import FileSaver from "file-saver";
import * as XLSX from "xlsx";

export function changeData(data) {
    if (typeof ArrayBuffer !== "undefined") {
        //1、创建一个字节长度为data.length的内存区域
        let buf = new ArrayBuffer(data.length);
        //2、创建一个指向buf的Unit8视图，开始于字节0，直到缓冲区的末尾
        let view = new Uint8Array(buf);

        //3、返回指定位置的字符的Unicode编码
        for (var i = 0; i != data.length; ++i)
            view[i] = data.charCodeAt(i) & 0xff;
        return buf;
    } else {
        let buf = new Array(data.length);
        for (var i = 0; i != data.length; ++i)
            buf[i] = data.charCodeAt(i) & 0xff;
        return buf;
    }
}

// 导出Excel
export function exportExcel(list, filename = "excel导出.xlsx") {
    let wopts = {
        bookType: "xlsx",
        bookSST: false,
        type: "binary",
    };
    let workBook = {
        SheetNames: ["Sheet1"],
        Sheets: {},
        Props: {},
    };

    workBook.Sheets["Sheet1"] = XLSX.utils.json_to_sheet(list);

    // XLSX.write() 开始编写Excel表格
    // changeData() 将数据处理成需要输出的格式
    FileSaver.saveAs(
        new Blob([changeData(XLSX.write(workBook, wopts))], {
            type: "application/octet-stream",
        }),
        filename
    );
}

// 导出多个Sheet的Excel
export function exportMultiSheetExcel(
    sheetNames,
    doubleList,
    filename = "excel导出.xlsx"
) {
    let wopts = {
        bookType: "xlsx",
        bookSST: false,
        type: "binary",
    };
    let workBook = {
        SheetNames: sheetNames,
        Sheets: {},
        Props: {},
    };

    sheetNames.forEach((name, index) => {
        workBook.Sheets[name] = XLSX.utils.json_to_sheet(doubleList[index]);
    });

    // XLSX.write() 开始编写Excel表格
    // changeData() 将数据处理成需要输出的格式
    FileSaver.saveAs(
        new Blob([changeData(XLSX.write(workBook, wopts))], {
            type: "application/octet-stream",
        }),
        filename
    );
}
